import React, { useState } from "react";
import { Container } from "components/Container";
import { ModalConfirmar } from "components/Modal/ModalConfirmar";
import { FormularioEditar } from "./formulario-editar";
import { FormularioService } from "services/FormularioService";
import { useHistory } from "react-router";
import * as atoms from "./EditarFormulariosStore";
import { useAtom } from "jotai";
import { useModalConfirmar } from "store/global";
import { notification } from "antd";
import { useParams } from "react-router-dom";

const EditarFormulariosPage = () => {
  let history = useHistory();
  const { formularioId } = useParams();
  const cerrarModalConfirmacion = useModalConfirmar((state) => state.cerrarModal);
  const [formulario] = useAtom(atoms.formulario);
  const [loading, setLoading] = useState(false);

  const onClickBtnConfirmarModal = async () => {
    try {
      setLoading(true);
      await FormularioService.actualizar(formulario, formularioId);
      cerrarModalConfirmacion();
      history.push("/configuracion/formularios/listar");
    } catch (error) {
      cerrarModalConfirmacion();
      console.error(error);
      notification.error({
        message: "No se puede actualizar el formulario",
        description: error.response.data.mensaje,
      });
    } finally {
      setLoading(false);
    }
  };
  const onClickBtnCancelarModal = () => {
    cerrarModalConfirmacion();
  };

  const onClickRetonarListarFormularios = () => {
    history.push("/configuracion/formularios/listar");
  };
  return (
    <div style={{ margin: "0px 15%" }}>
      <Container titulo="Editar Tipo Documento" onClickRetornar={onClickRetonarListarFormularios}>
        <FormularioEditar />
        <ModalConfirmar
          loading={loading}
          mensaje="¿Está seguro de actualizar el formulario? "
          onClickBtnCancelar={onClickBtnCancelarModal}
          onClickBtnConfirmar={onClickBtnConfirmarModal}
        />
      </Container>
    </div>
  );
};
export default EditarFormulariosPage;
